import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  AccessRequest,
  AccessRequestFilters,
  AccessRequestStatusUpdate,
} from '../models/access-request.model';

/**
 * Bandeja de solicitudes de acceso (lado administración).
 *
 * <p>El envío desde la pantalla pública vive en `AccessRequestApiService` de
 * `auth-pages/services` — es otro endpoint (`/api/public/access-requests`) y no
 * lleva token.</p>
 *
 * <p>Sin `businessId`: la tabla es global, porque quien solicita todavía no
 * pertenece a ninguna empresa. El backend protege estos endpoints con los mismos
 * permisos que Invitaciones (módulo `users`).</p>
 */
@Injectable({ providedIn: 'root' })
export class AccessRequestAdminApiService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiUrl}api/access-requests`;

  list(filters: AccessRequestFilters = {}): Observable<AccessRequest[]> {
    let params = new HttpParams();
    if (filters.status !== undefined) {
      params = params.set('status', filters.status);
    }
    if (filters.page !== undefined) {
      params = params.set('page', String(filters.page));
    }
    if (filters.size !== undefined) {
      params = params.set('size', String(filters.size));
    }
    return this.http.get<AccessRequest[]>(this.apiUrl, { params });
  }

  countByStatus(status: string): Observable<number> {
    const params = new HttpParams().set('status', status);
    return this.http.get<number>(`${this.apiUrl}/count`, { params });
  }

  updateStatus(
    id: number,
    body: AccessRequestStatusUpdate,
  ): Observable<AccessRequest> {
    return this.http.patch<AccessRequest>(`${this.apiUrl}/${id}/status`, body);
  }
}
